import FlatPartnerProductList from './FlatPartnerProductList'

export default FlatPartnerProductList
